module.exports = __webpack_public_path__ + "static/media/B39871 - Notice of Proposal to Apply Conditions .bc94ff4d.pdf";